import { takeLatest, all, takeEvery } from 'redux-saga/effects'; // fork, take,  takeEvery, takeLeading
import { SAGA_ACTIONS } from '../../_config';

import * as userSaga from './userSaga';
import * as facilitiesSaga from './facilitiesSaga';
import * as assetsSaga from './assetsSaga';
import * as commonSaga from './commonSaga';
import * as spearPartsSaga from './spearPartsSaga';
import * as stockAdjustmentSaga from './stockAdjustmentSaga';
import * as cycleCountSaga from './cycleCountSaga';


export function* sagas() {
	yield all([
		takeEvery(SAGA_ACTIONS.USER.LOGIN, userSaga.login),
		takeEvery(SAGA_ACTIONS.USER.LOGOUT, userSaga.logout),
		takeEvery(SAGA_ACTIONS.USER.REGISTER, userSaga.register),
		takeEvery(SAGA_ACTIONS.USER.FORGET_PASSWORD, userSaga.forgotPassword),
		takeEvery(SAGA_ACTIONS.USER.RESET_PASSWORD, userSaga.resetPassword),
		takeEvery(SAGA_ACTIONS.FACILITY.GET_FACILITY_LIST, facilitiesSaga.GetFacilityList),
		takeEvery(SAGA_ACTIONS.FACILITY.GET_FACILITY_DETAILS, facilitiesSaga.getFacilityDetails),
		takeEvery(SAGA_ACTIONS.FACILITY.SAVE_FACILITY, facilitiesSaga.SaveFacility),
		
		takeEvery(SAGA_ACTIONS.FACILITY.GET_SUB_FACILITY_LIST, facilitiesSaga.GetSubFacilityList),
		takeEvery(SAGA_ACTIONS.FACILITY.SAVE_SUB_FACILITY, facilitiesSaga.SaveSubFacility),
		takeEvery(SAGA_ACTIONS.FACILITY.GET_SUB_FACILITY_TYPE_LIST, facilitiesSaga.GetSubFacilityTypeList),
		takeEvery(SAGA_ACTIONS.FACILITY.SAVE_SUB_FACILITY_IMAGE, facilitiesSaga.SaveSubFacilityImage),
		takeEvery(SAGA_ACTIONS.FACILITY.SAVE_FACILITY_IMAGE, facilitiesSaga.SaveFacilityImage),

		takeEvery(SAGA_ACTIONS.FACILITY.DELETE_FACILITY, facilitiesSaga.DeleteFacility),
		takeEvery(SAGA_ACTIONS.FACILITY.GET_PROCESSING_FACILITY_LIST, facilitiesSaga.GetProcessingFacilityList),
		takeEvery(SAGA_ACTIONS.FACILITY.GET_FACILITY_CODE, facilitiesSaga.getFacilityCode),
		takeEvery(SAGA_ACTIONS.FACILITY.EXPORT_TO_CSV, facilitiesSaga.Exportcsv),
		takeEvery(SAGA_ACTIONS.FACILITY.EXPORT_TO_PDF, facilitiesSaga.Exportpdf),
		takeEvery(SAGA_ACTIONS.FACILITY.EXPORT_QR_CODE, facilitiesSaga.ExportQRCode),




		takeEvery(SAGA_ACTIONS.ASSETS.NOTE_LIST, assetsSaga.GetnoteList),
		takeEvery(SAGA_ACTIONS.ASSETS.NOTE_SAVE, assetsSaga.saveNotes),
		takeEvery(SAGA_ACTIONS.ASSETS.DELETE_NOTES, assetsSaga.deleteNotes),

		takeEvery(SAGA_ACTIONS.ASSETS.GET_ASSET_ATTACHMENT, assetsSaga.GetAttachmentList),
		takeEvery(SAGA_ACTIONS.ASSETS.SAVE_ASSET_ATTACHMENT, assetsSaga.SaveAssetAttachment),
		takeEvery(SAGA_ACTIONS.ASSETS.SAVE_ASSET_IMAGE, assetsSaga.SaveAssetImage),
		takeEvery(SAGA_ACTIONS.ASSETS.DELETE_ASSET_ATTACHMENT, assetsSaga.DeleteAssetAttachment),

		takeEvery(SAGA_ACTIONS.ASSETS.EXPORT_TO_CSV, assetsSaga.Exportcsv),
		takeEvery(SAGA_ACTIONS.ASSETS.EXPORT_TO_PDF, assetsSaga.Exportpdf),
		takeEvery(SAGA_ACTIONS.ASSETS.EXPORT_QR_CODE, assetsSaga.ExportQrCode),
  
		takeEvery(SAGA_ACTIONS.ASSETS.GET_ASSETS_LIST, assetsSaga.GetAssetsList),
		takeEvery(SAGA_ACTIONS.ASSETS.GET_ASSET_CODE, assetsSaga.GetAssetCode),
		takeEvery(SAGA_ACTIONS.ASSETS.GET_ASSET_CATEGORY, assetsSaga.GetAssetCategory),
		takeEvery(SAGA_ACTIONS.ASSETS.GET_ASSET_DEPARTMENT, assetsSaga.GetAssetDepartment),
		takeEvery(SAGA_ACTIONS.ASSETS.GET_ASSET_GROUPLIST, assetsSaga.GetAssetGroupList),
		takeEvery(SAGA_ACTIONS.ASSETS.GET_ASSET_SUBGROUPLIST, assetsSaga.GetAssetSubGroupList),
		takeEvery(SAGA_ACTIONS.ASSETS.GET_ASSET_TYPE_LIST, assetsSaga.GetAssetTypeList),
		takeEvery(SAGA_ACTIONS.ASSETS.GET_ASSET_CLASIFICATION_LIST, assetsSaga.GetAssetClassificationList),
		takeEvery(SAGA_ACTIONS.ASSETS.GET_ASSET_STATUS_LIST, assetsSaga.GetAssetStatusList),
		takeEvery(SAGA_ACTIONS.ASSETS.SAVE_ASSETS, assetsSaga.saveAssets),
		takeEvery(SAGA_ACTIONS.ASSETS.DELETE_ASSETS, assetsSaga.deleteAsset),
		takeEvery(SAGA_ACTIONS.ASSETS.UPDATE_STATUS, assetsSaga.updateStatus),
		

		takeEvery(SAGA_ACTIONS.ASSETS.GET_VENDOR_LIST, assetsSaga.GetvenderList),

		

		
		takeEvery(SAGA_ACTIONS.COMMON.GET_CITY, commonSaga.GetCityList),
		takeEvery(SAGA_ACTIONS.COMMON.GET_COUNTY, commonSaga.GetCountyList),
		takeLatest(SAGA_ACTIONS.COMMON.GET_STATE, commonSaga.GetStateList),
		takeEvery(SAGA_ACTIONS.COMMON.GET_TEAM, commonSaga.Getteam),
		takeLatest(SAGA_ACTIONS.COMMON.GET_USER, commonSaga.GetUser),
		takeEvery(SAGA_ACTIONS.COMMON.GET_SERVICE_TECH, commonSaga.GetServiceTechList),
		takeEvery(SAGA_ACTIONS.COMMON.GET_SERVICE_PROVIDER_LIST, commonSaga.GetServiceProviderList),
		
		
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.GET_SPEAR_PARTS_LIST, spearPartsSaga.getSpearPartsList), 
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.GET_SPEAR_PARTS_CODE, spearPartsSaga.getSpearPartsCode),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.SAVE_SPEAR_PARTS, spearPartsSaga.saveSpearParts),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.DELETE_SPEAR_PARTS, spearPartsSaga.deleteSpearParts),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_ATTACHMENTS, spearPartsSaga.getPartsAttachments),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.SAVE_PARTS_ATTACHMENTS, spearPartsSaga.savePartsAttachments),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.SAVE_PARTS_IMAGE, spearPartsSaga.savePartsImage),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.DELETE_PARTS_ATTACHMENTS, spearPartsSaga.deletePartsAttachments),

		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.EXPORT_TO_PDF, spearPartsSaga.exportToPdf),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.EXPORT_TO_XLS, spearPartsSaga.exportToXls),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.EXPORT_QR_CODE, spearPartsSaga.ExportQRCode),

		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_STATUS, spearPartsSaga.getPartsStatus),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_CATEGORY_LIST, spearPartsSaga.getSparePartsCategoryList),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_UNIT_LIST, spearPartsSaga.getPartsUnitList),

		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_NOTES_LIST, spearPartsSaga.GetPartsNotesList),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.SAVE_PARTS_NOTES, spearPartsSaga.SavePartsNotes),

		
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.LOCATION_WISE_STOCK, spearPartsSaga.locationWiseStock),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.PURCHASE_HISTORY, spearPartsSaga.getPurchaseHistory),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.STOCK_PICKING_HISTORY, spearPartsSaga.getStockPickingHistory),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.STOCK_CYCLE_COUNT_HISTORY, spearPartsSaga.getStockCycleCountHistory),
		takeEvery(SAGA_ACTIONS.SPEAR_PARTS.STOCK_ADJUSTMENT_HISTORY, spearPartsSaga.getStockAdjustmentHistory),




		takeEvery(SAGA_ACTIONS.STOCK_ADJUSTMENT.LIST, stockAdjustmentSaga.getStockAdjustmentList),
		takeEvery(SAGA_ACTIONS.STOCK_ADJUSTMENT.SAVE, stockAdjustmentSaga.saveStockAdjustmentList),
		takeEvery(SAGA_ACTIONS.STOCK_ADJUSTMENT.DELETE, stockAdjustmentSaga.deleteStockAdjustmentList),
		
		takeEvery(SAGA_ACTIONS.STOCK_ADJUSTMENT.EXPORT_TO_PDF, stockAdjustmentSaga.exportToPdf),
		takeEvery(SAGA_ACTIONS.STOCK_ADJUSTMENT.EXPORT_TO_XLS, stockAdjustmentSaga.exportToXls),
		takeEvery(SAGA_ACTIONS.STOCK_ADJUSTMENT.EXPORT_QR_CODE, stockAdjustmentSaga.ExportQRCode),
		takeEvery(SAGA_ACTIONS.STOCK_ADJUSTMENT.GET_ID, stockAdjustmentSaga.getStockAdjustmentCode),
		takeEvery(SAGA_ACTIONS.STOCK_ADJUSTMENT.GET_BY_ID, stockAdjustmentSaga.getStockAdjustmentByID),
		takeEvery(SAGA_ACTIONS.STOCK_ADJUSTMENT.MOVE_STOCK, stockAdjustmentSaga.MoveStock),

		takeEvery(SAGA_ACTIONS.CYCLE_COUNT.GET_BY_ID, cycleCountSaga.GetByID),
		takeEvery(SAGA_ACTIONS.CYCLE_COUNT.GET_BY_PART_NAME, cycleCountSaga.GetByPartName),
		takeEvery(SAGA_ACTIONS.CYCLE_COUNT.LIST, cycleCountSaga.GetList),
		takeEvery(SAGA_ACTIONS.CYCLE_COUNT.SAVE, cycleCountSaga.Save),
		takeEvery(SAGA_ACTIONS.CYCLE_COUNT.DELETE, cycleCountSaga.Delete),
		takeEvery(SAGA_ACTIONS.CYCLE_COUNT.EXPORT_TO_PDF, cycleCountSaga.ExportToPdf),
		takeEvery(SAGA_ACTIONS.CYCLE_COUNT.EXPORT_TO_XLS, cycleCountSaga.ExportToXls),
		takeEvery(SAGA_ACTIONS.CYCLE_COUNT.GET_ID, cycleCountSaga.GetID),		
		takeEvery(SAGA_ACTIONS.CYCLE_COUNT.ADD_STOCK_PICKING, cycleCountSaga.AddStockPicking),
		takeEvery(SAGA_ACTIONS.CYCLE_COUNT.GET_STOCK_PICKING, cycleCountSaga.GetStockPicking),
		takeEvery(SAGA_ACTIONS.CYCLE_COUNT.STOCK_COUNT, cycleCountSaga.GetStockCount),


	]);
}